import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

const StyledBadge = styled(Badge)(() => {
  const { breakpoints } = useTheme();

  return {
    '& .MuiBadge-badge': {
      backgroundColor: colors.redBright,
      color: colors.redBright,
      top: 0,
      right: 0,
      minWidth: '10px',
      minHeight: '10px',
      borderRadius: '50%',
      //boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        minWidth: '6px',
        minHeight: '6px',
        height: '6px',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  };
});

export default StyledBadge;
